export function applicationConfigurationModelFromDto(dto) {
    const slug = dto.applicationType.slug;
    const isComputerLoginWithAD = slug === 'computer-login';
    const isOffice365 = slug === 'office-365';
    const isEPM = slug === 'enterprise-password-manager';
    const isSaaspassDemo = slug === 'saaspass-demo';
    const isSaaspassMySqlConnector = slug === 'saaspass-my-sql-connector';

    return {
        adDomain: dto.adDomain,
        appDomain: dto.appDomain,
        applicationName: dto.applicationName,
        applicationTypeId: dto.applicationType.applicationTypeId,
        applicationTypeDisplayName: dto.applicationType.applicationTypeDisplayName,
        companyAdDomains: dto.companyAdDomains,
        configDTO: dto.configDTO,
        configElements: (((dto.configDTO || {}).appConfig || {}).elements || [])
            .map(({name, label, placeholder, value, required, validations}) => {
                const type = (validations || []).map(v => v.type).find(Boolean);
                return {name, label, placeholder, value, required, type};
            }),
        customIconUrl: dto.customIconUrl,
        epmAppSettings: dto.epmAppSettings,
        isComputerLoginWithAD,
        isEPM,
        isOffice365,
        isRunning: dto.status === 'RUNNING',
        samlAppLogo: window.env.urls.samlAppLogo(slug, 'thumb'),
        isSaaspassDemo,
        isSaaspassMySqlConnector,
        provisioningUrl: dto.provisioningUrl,
        mysqlSshParams: dto.mysqlSshParams,
    };
}

export function applicationConfigurationModelToDto(model) {
    return {
        adDomain: model.adDomain,
        appDomain: model.appDomain,
        applicationName: model.applicationName,
        configDTO: model.configDTO && {
            ...model.configDTO,
            appConfig: model.configDTO.appConfig && {
                ...model.configDTO.appConfig,
                elements: model.configElements.map(({name, value}) => ({name, value}))
            },
        },
        epmAppSettings: model.epmAppSettings,
        status: model.isRunning ? 'RUNNING' : 'PAUSED',
        provisioningUrl: model.provisioningUrl,
        mysqlSshParams: model.mysqlSshParams,
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/configuration/application-configuration-form.functions.js